import axios from 'axios';
import { toast } from 'react-toastify';
import { CART_ADD_ITEM, CART_REMOVE_ITEM, CART_UPDATE_QUANTITIES,CART_UPDATE_KURIR } from './cartActionTypes';
import { updateAction } from '../auth/authActions';

export function cartAddItemSuccess(product, options = [], quantity = 1) {
    toast.success(`Produk "${product.item_name || product.name || 'Produk'}" berhasil ditambahkan ke keranjang`);

    return {
        type: CART_ADD_ITEM,
        product,
        options,
        quantity,
    };
}

export function cartRemoveItemSuccess(itemId) {
    return {
        type: CART_REMOVE_ITEM,
        itemId,
    };
}

export function cartRemoveItemSuccess1(id) {
    return {
        type: CART_REMOVE_ITEM,
        id,
    };
}

export function cartUpdateQuantitiesSuccess(quantities) {
    return {
        type: CART_UPDATE_QUANTITIES,
        quantities,
    };
}

export function cartUpdateKurirCokSuccess(listkurir) {
    return {
        type: CART_UPDATE_KURIR,
        listkurir,
    };
}

export function cartAddItem(product, options = [], quantity = 1) {
    return async (dispatch, getState) => {
        const token = getState()?.auth?.token || localStorage.getItem('token');
        if (!token) {
            toast.warning('Silakan login terlebih dahulu untuk menambah ke keranjang');
            return;
        }

        const body = {
            item_id: product.item_id || product.id,
            qty: quantity || 1,
            type: product.type || 'normal',
            price_6: product.price_6 || product.price || 0,
            warehouse_id: product.warehouse_id || 1,
        };

        try {
            await axios({
                method: 'POST',
                url: `${process.env.REACT_APP_HOST_API}/cart/save`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: body,
            });

            dispatch(cartAddItemSuccess(product, options, quantity));

            try {
                const res = await axios({
                    method: 'GET',
                    url: `${process.env.REACT_APP_HOST_API}/cart/list`,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const items = Array.isArray(res.data?.response) ? res.data.response : [];
                const sum = items.reduce((acc, curr) => acc + (parseInt(curr.qty, 10) || 0), 0);
                localStorage.setItem('cart_total', sum);
                window.dispatchEvent(new CustomEvent('cart:count_updated', { detail: sum }));
            } catch (e) {
                // fallback
            }

            dispatch(updateAction(Date.now()));
        } catch (error) {
            console.error('Error adding to cart:', error);
            toast.error(error.response?.data?.message || 'Gagal menambahkan produk ke keranjang');
        }
    };
}

export function cartRemoveItem(itemId) {
    // sending request to server, timeout is used as a stub
    return (dispatch) => (
        new Promise((resolve) => {
            setTimeout(() => {
                dispatch(cartRemoveItemSuccess(itemId));
                resolve();
            }, 500);
        })
    );
}

export function PengirimanHandler(id) {
    // sending request to server, timeout is used as a stub
    return (dispatch) => (
        new Promise((resolve) => {
            setTimeout(() => {
                dispatch(cartRemoveItemSuccess1(id));
                resolve();
            }, 500);
        })
    );
}

export function cartUpdateQuantities(quantities) {
    // sending request to server, timeout is used as a stub
    return (dispatch) => (
        new Promise((resolve) => {
            setTimeout(() => {
                dispatch(cartUpdateQuantitiesSuccess(quantities));
                resolve();
            }, 500);
        })
    );
}

export function cartUpdateKurirCok(listkurir) {
    // sending request to server, timeout is used as a stub
    return (dispatch) => (
        new Promise((resolve) => {
            setTimeout(() => {
                dispatch(cartUpdateKurirCokSuccess(listkurir));
                resolve();
            }, 500);
        })
    );
}
